import React, { useState } from 'react';
import { translate } from "../../Services/translation";
import Svg from "../../Components/Svg";

const targetElementSelector = ".filter-wrapper";
const activeClass = "is-open";

const MobileFilterTrigger = function() {
    const targetElement = document.querySelector(targetElementSelector);
    if (!targetElement) return null;

    const [open, setOpen] = useState(targetElement.classList.contains(activeClass));

    const onClick = () => {
        targetElement.classList.toggle(activeClass);
        setOpen(targetElement.classList.contains(activeClass));
    }

    const textKeyPartial = open ? "closefilter" : "filter";
    const icon = open ? "close" : "filter";

    return <>
        <button className="filter-wrapper__trigger large:d-none" onClick={onClick}>
            {translate(`muha.category.${textKeyPartial}`)} <Svg icon={icon} />
        </button>
    </>
}

export default MobileFilterTrigger;
